import React, { useState } from "react";
import { useWorkspaceStore } from "@/hooks/useWorkspace";
import { showCustomToast } from "../CustomToast";
import CopyGrey from "@/assets/icons/CopyGrey.svg";

const SettingsMCP = () => {
  const { currentWorkspace } = useWorkspaceStore();
  const bugReportUrl = `https://app.usetool.bar/dashboard/${currentWorkspace?._id}`;

  const handleCopy = (text: string, message: string) => {
    navigator.clipboard.writeText(text);
    showCustomToast(message, "check");
  };

  const steps = [
    {
      title: (
        <>
          Install{" "}
          <a
            target="_blank"
            href="https://code.claude.com/docs/en/ide-integrations"
            className="underline decoration-gray-900"
          >
            Claude Code in your IDE
          </a>
        </>
      ),
      description: null,
      content: null,
    },
    {
      title: "Run this command in your terminal in your project",
      description: null,
      content: (
        <div className="mt-4 flex items-center justify-between gap-4 bg-white/[0.08] py-3 border-white/[0.08] border-l-[4px] px-4">
          <div className="geist text-[14px] leading-[20px] flex-1 break-words">
            <span className="text-[#569CD6]">claude</span>{" "}
            <span className="text-[#CE9178]">mcp</span>{" "}
            <span className="text-[#CE9178]">add</span>{" "}
            <span className="text-[#CE9178]">Toolbar</span>{" "}
            <span className="text-[#CE9178]">https://mcp.usetool.bar/mcp</span>{" "}
            <span className="text-[#CE9178]">-t</span>{" "}
            <span className="text-[#CE9178]">http</span>{" "}
            <span className="text-[#CE9178]">-s</span>{" "}
            <span className="text-[#CE9178]">user</span>
          </div>
          <button
            onClick={() =>
              handleCopy(
                "claude mcp add Toolbar https://mcp.usetool.bar/mcp -t http -s user",
                "Command copied",
              )
            }
            className="geist transition-all text-[14px] leading-[20px] font-medium text-white/[0.56] hover:text-white flex-shrink-0"
          >
            COPY
          </button>
        </div>
      ),
    },
    {
      title: "How to use it: Paste your bug report link to Claude",
      description:
        "Copy any Toolbar report link and paste it into Claude Code to get AI-powered fixes",
      // content: (
      //   <div
      //     className="mt-2 relative cursor-pointer"
      //     onClick={() => handleCopy(bugReportUrl, "Bug report link copied")}
      //   >
      //     <div className="rounded-[12px] h-[36px] w-full text-[14px] truncate leading-[20px] px-4 pr-12 outline-none ring-0 text-white bg-white/[0.04] border-[1px] border-white/[0.08] py-2">
      //       {bugReportUrl}
      //     </div>
      //     <button className="absolute right-4 top-1/2 -translate-y-1/2 rounded-[8px] transition-all">
      //       <img src={CopyGrey} />
      //     </button>
      //   </div>
      // ),
      content: null,
    },
  ];

  return (
    <div className="flex flex-col">
      <h1 className="text-[20px] leading-[28px] font-semibold text-gray-900 mb-6">
        Configure Toolbar MCP for Claude Code
      </h1>

      <div className="flex flex-col gap-6">
        {steps.map((step, index) => (
          <div key={index} className="flex items-start gap-6 relative">
            <div className="flex flex-col items-center flex-shrink-0">
              <div className="w-[32px] h-[32px] rounded-[10px] bg-gray-400 border-[1px] border-gray-500 flex items-center justify-center font-semibold text-[16px] leading-[24px]">
                {index + 1}
              </div>
              {index < steps.length - 1 && (
                <div className="w-[1px] bg-white/[0.16] absolute top-[32px] bottom-[-24px]" />
              )}
            </div>
            <div className="flex-1 min-w-0">
              <h2
                className={`text-[16px] leading-[32px] font-semibold text-gray-900 ${step.description || step.content ? "mb-1" : ""}`}
              >
                {step.title}
              </h2>
              {step.description && (
                <p className="text-[14px] leading-[20px] text-white/[0.56] font-medium">
                  {step.description}
                </p>
              )}
              {step.content}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SettingsMCP;
